import { useEffect, useRef } from "react";

// The preview runs dashes along the connector lines toward Fydo and pulses
// the ring behind the centre circle. Driven with the Web Animations API so no
// global keyframes are needed; skipped when the visitor prefers reduced
// motion (the hub then shows its resting state).
export function useHubMotion() {
  const linesRef = useRef<SVGGElement>(null);
  const ringRef = useRef<SVGCircleElement>(null);

  useEffect(() => {
    const startMotion = () => {
      const reduce = window.matchMedia(
        "(prefers-reduced-motion: reduce)",
      ).matches;
      const lines = linesRef.current;
      const ring = ringRef.current;
      if (reduce || !lines || !ring) return [];
      return [
        lines.animate(
          [{ strokeDashoffset: 0 }, { strokeDashoffset: -28 }],
          { duration: 1600, easing: "linear", iterations: Infinity },
        ),
        ring.animate(
          [
            { transform: "scale(1)", opacity: 0.95 },
            { transform: "scale(1.16)", opacity: 0.5 },
            { transform: "scale(1)", opacity: 0.95 },
          ],
          { duration: 2600, easing: "ease-in-out", iterations: Infinity },
        ),
      ];
    };
    const animations = startMotion();
    return () => animations.forEach((animation) => animation.cancel());
  }, []);

  return { linesRef, ringRef };
}
